(function () {
  'use strict';

  // ---- Scroll-to-anchor delegation (used by rating block etc) ----
  if (!window.__kicaScrollAnchorBound) {
    window.__kicaScrollAnchorBound = true;

    var REVIEW_ANCHOR_FALLBACKS = [
      '#kica-reviews-anchor',
      '#judgeme_product_reviews',
      '#looxReviews',
      '#judge-me-reviews',
      '[id^="judgeme"]',
    ];

    var scrollToTarget = function (target) {
      if (!target) return false;
      var el = null;
      // Try as bare id first, then as CSS selector
      if (/^[a-zA-Z][\w\-:.]*$/.test(target)) {
        el = document.getElementById(target);
      }
      if (!el) {
        try { el = document.querySelector(target); } catch (e) { /* invalid selector */ }
      }
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }
      return false;
    };

    var scrollToReviews = function () {
      for (var i = 0; i < REVIEW_ANCHOR_FALLBACKS.length; i++) {
        if (scrollToTarget(REVIEW_ANCHOR_FALLBACKS[i])) return true;
      }
      console.warn('[KICA] no review anchor found on this page');
      return false;
    };

    // Back-compat shim for old custom Liquid blocks that call scrollToAnchor()
    // (e.g. product.unique.json rating block still has onclick="scrollToAnchor()").
    if (typeof window.scrollToAnchor !== 'function') {
      window.scrollToAnchor = function (id) {
        if (id && scrollToTarget(id)) return;
        scrollToReviews();
      };
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-kica-scroll-to]');
      if (!trigger) return;
      var v = trigger.getAttribute('data-kica-scroll-to');
      if (v && !scrollToTarget(v)) scrollToReviews();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var trigger = e.target.closest && e.target.closest('[data-kica-scroll-to]');
      if (!trigger) return;
      e.preventDefault();
      var v = trigger.getAttribute('data-kica-scroll-to');
      if (v && !scrollToTarget(v)) scrollToReviews();
    });
  }

  if (window.__kicaFavoritesLoaded) return;
  window.__kicaFavoritesLoaded = true;

  var PROXY_BASE = '/apps/library';
  var STORAGE_KEY = 'kica_favorites_v2';
  var LEGACY_KEY = 'kica_favorites_v1';
  var MERGE_FLAG_KEY = 'kica_favorites_merged_at';

  var state = {
    loggedIn: false,
    favorites: [],
    productCache: new Map(),
    pending: new Set(),
    drawer: null,
    drawerInitialized: false,
  };

  function getButtons() {
    return document.querySelectorAll('[data-kica-fav]');
  }

  function inferLoggedIn() {
    if (state.drawer && state.drawer.dataset.customerId) return true;
    var btns = getButtons();
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].dataset.customerId) return true;
    }
    return false;
  }

  function migrateLegacy() {
    try {
      var legacy = localStorage.getItem(LEGACY_KEY);
      if (!legacy) return;
      var parsed = JSON.parse(legacy);
      if (Array.isArray(parsed) && parsed.length > 0) {
        var migrated = parsed.map(function (id) {
          return { id: String(id), handle: '', title: '' };
        });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(migrated));
      }
      localStorage.removeItem(LEGACY_KEY);
    } catch (e) {}
  }

  function readLocal() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (it) { return it && it.id; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeLocal(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function favoritesHasId(id) {
    var sid = String(id);
    return state.favorites.some(function (f) { return String(f.id) === sid; });
  }

  function setFilled(btn, filled) {
    btn.classList.toggle('is-filled', !!filled);
    btn.setAttribute('aria-pressed', filled ? 'true' : 'false');
    var label = filled ? 'Remove from wishlist' : 'Save to wishlist';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }

  function refreshAllButtonsState() {
    getButtons().forEach(function (btn) {
      var id = String(btn.dataset.productId || '');
      setFilled(btn, favoritesHasId(id));
    });
  }

  async function workerGet() {
    var res = await fetch(PROXY_BASE + '/favorites', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    var body = await res.json();
    return (body.favorites || []).map(function (f) {
      return {
        id: String(f.shopify_product_id),
        handle: f.handle || '',
        title: f.title || '',
      };
    });
  }

  async function workerAdd(item) {
    var res = await fetch(PROXY_BASE + '/favorites', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shopify_product_id: String(item.id) }),
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
  }

  async function workerRemove(id) {
    var res = await fetch(
      PROXY_BASE + '/favorites?shopify_product_id=' + encodeURIComponent(id),
      { method: 'DELETE', credentials: 'same-origin', headers: { Accept: 'application/json' } }
    );
    if (!res.ok) throw new Error('HTTP ' + res.status);
  }

  async function mergeLocalIntoServer() {
    var local = readLocal();
    if (local.length === 0) return;
    var results = await Promise.allSettled(
      local.map(function (it) { return workerAdd(it); })
    );
    var failed = local.filter(function (_it, i) { return results[i].status === 'rejected'; });
    writeLocal(failed);
    try { localStorage.setItem(MERGE_FLAG_KEY, String(Date.now())); } catch (e) {}
  }

  async function reloadFavorites() {
    if (state.loggedIn) {
      try {
        state.favorites = await workerGet();
      } catch (e) {
        console.warn('[kica-favorites] fetch failed:', e);
        state.favorites = [];
      }
    } else {
      state.favorites = readLocal();
    }
    refreshAllButtonsState();
  }

  function buildItemFromButton(btn) {
    return {
      id: String(btn.dataset.productId || ''),
      handle: String(btn.dataset.productHandle || ''),
      title: String(btn.dataset.productTitle || ''),
    };
  }

  async function handleClick(btn) {
    var item = buildItemFromButton(btn);
    if (!item.id || state.pending.has(item.id)) return;
    state.pending.add(item.id);
    btn.classList.add('is-loading');

    var currentlyFilled = btn.classList.contains('is-filled');
    var nextFilled = !currentlyFilled;
    setFilled(btn, nextFilled);

    try {
      if (state.loggedIn) {
        if (nextFilled) {
          await workerAdd(item);
          state.favorites.push(item);
        } else {
          await workerRemove(item.id);
          state.favorites = state.favorites.filter(function (f) { return String(f.id) !== item.id; });
        }
      } else {
        if (nextFilled) {
          var local = readLocal();
          if (!local.some(function (f) { return String(f.id) === item.id; })) {
            local.push(item);
          }
          writeLocal(local);
          state.favorites = local;
        } else {
          state.favorites = readLocal().filter(function (f) { return String(f.id) !== item.id; });
          writeLocal(state.favorites);
        }
      }
    } catch (e) {
      console.warn('[kica-favorites] toggle failed:', e);
      setFilled(btn, currentlyFilled);
    } finally {
      btn.classList.remove('is-loading');
      state.pending.delete(item.id);
    }

    document.querySelectorAll(
      '[data-kica-fav][data-product-id="' + item.id + '"]'
    ).forEach(function (other) {
      if (other !== btn) setFilled(other, nextFilled);
    });
  }

  async function fetchProductByHandle(handle) {
    if (!handle) return null;
    if (state.productCache.has(handle)) return state.productCache.get(handle);
    var promise = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    state.productCache.set(handle, promise);
    return promise;
  }

  function formatMoney(cents, currency) {
    var value = (Number(cents || 0) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      maximumFractionDigits: 2,
    });
    return value;
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderDrawerItem(item, productJson) {
    var image = productJson && productJson.featured_image
      ? productJson.featured_image
      : '';
    var price = productJson && productJson.price != null
      ? formatMoney(productJson.price)
      : '';
    var url = productJson && productJson.url ? productJson.url : (item.handle ? '/products/' + item.handle : '#');
    var title = (productJson && productJson.title) || item.title || 'Product';

    return (
      '<li class="kica-fav-item" data-kica-fav-item data-product-id="' + escapeHtml(item.id) + '">' +
        '<a class="kica-fav-item__link" href="' + escapeHtml(url) + '">' +
          (image
            ? '<img class="kica-fav-item__img" src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" loading="lazy" />'
            : '<span class="kica-fav-item__img kica-fav-item__img--placeholder"></span>'
          ) +
          '<span class="kica-fav-item__meta">' +
            '<span class="kica-fav-item__title">' + escapeHtml(title) + '</span>' +
            (price ? '<span class="kica-fav-item__price">' + escapeHtml(price) + '</span>' : '') +
          '</span>' +
        '</a>' +
        '<button class="kica-fav-item__remove" type="button" aria-label="Remove" data-kica-fav-remove="' + escapeHtml(item.id) + '">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.1C.6 8 2.6 4 6.5 4c2 0 3.5 1 4.5 2.4l1 1.4 1-1.4C14 5 15.5 4 17.5 4c3.9 0 5.9 4 4.1 7.9C19.5 16.4 12 21 12 21z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>' +
        '</button>' +
      '</li>'
    );
  }

  function showState(name) {
    var states = state.drawer.querySelectorAll('[data-kica-fav-state]');
    states.forEach(function (el) {
      if (el.dataset.kicaFavState === name) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    var list = state.drawer.querySelector('[data-kica-fav-list]');
    if (list) {
      if (name === 'list') list.removeAttribute('hidden');
      else list.setAttribute('hidden', '');
    }
  }

  async function populateDrawer() {
    if (!state.drawer) return;
    var list = state.drawer.querySelector('[data-kica-fav-list]');
    if (!list) return;

    if (!state.loggedIn && state.favorites.length === 0) {
      showState('guest');
      return;
    }
    if (state.favorites.length === 0) {
      showState('empty');
      return;
    }

    showState('loading');

    var items = state.favorites.slice();
    var products = await Promise.all(items.map(function (it) { return fetchProductByHandle(it.handle); }));

    list.innerHTML = items.map(function (it, i) { return renderDrawerItem(it, products[i]); }).join('');
    showState('list');
    list.removeAttribute('hidden');

    if (!state.loggedIn) {
      var guestNote = state.drawer.querySelector('[data-kica-fav-state="guest"]');
      if (guestNote) guestNote.removeAttribute('hidden');
    }
  }

  function attachDrawerHandlers() {
    if (state.drawerInitialized || !state.drawer) return;
    state.drawerInitialized = true;

    state.drawer.addEventListener('drawer:afterShow', populateDrawer);

    state.drawer.addEventListener('click', function (e) {
      var target = e.target;
      while (target && target !== state.drawer) {
        if (target.matches && target.matches('[data-kica-fav-remove]')) {
          var id = target.getAttribute('data-kica-fav-remove');
          removeFromDrawer(id);
          return;
        }
        target = target.parentNode;
      }
    });
  }

  async function removeFromDrawer(productId) {
    var pid = String(productId);
    try {
      if (state.loggedIn) {
        await workerRemove(pid);
        state.favorites = state.favorites.filter(function (f) { return String(f.id) !== pid; });
      } else {
        state.favorites = readLocal().filter(function (f) { return String(f.id) !== pid; });
        writeLocal(state.favorites);
      }
    } catch (e) {
      console.warn('[kica-favorites] remove failed:', e);
      return;
    }
    refreshAllButtonsState();
    var node = state.drawer.querySelector('[data-kica-fav-item][data-product-id="' + pid + '"]');
    if (node) node.remove();
    if (state.favorites.length === 0) showState(state.loggedIn ? 'empty' : 'guest');
  }

  async function init() {
    migrateLegacy();
    state.drawer = document.getElementById('FavoritesDrawer');
    state.loggedIn = inferLoggedIn();

    if (state.loggedIn) {
      try { await mergeLocalIntoServer(); } catch (e) {}
    }
    await reloadFavorites();

    getButtons().forEach(function (btn) {
      btn.addEventListener('click', function () { handleClick(btn); });
    });

    attachDrawerHandlers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
